const Gym = props => {
    return (
        <svg className={props.className || ""} viewBox="0 -960 960 960"><path d="m539.85-94-46-46 142-142L282-635.85l-142 142-46-46 56.77-58-46-46 84-84-56-57.23 42.15-42.15 57.23 56 84-84 46 46 58-56.77 46 46-142 142L678-324.15l142-142 46 46-56.77 58 46 46-84 84 56 57.23-42.15 42.15-57.23-56-84 84-46-46-58 56.77Z"/></svg>
    )
}

export default Gym;